import { Box, Container, Grid, Item, Typography } from '@material-ui/core'
import classNames from 'classnames'
import Image from 'components/image'
import { babylistUrl, helloBabyAuthors } from 'lib/urls'
import HelloBabyMeta from './HelloBabyMeta'
import SocialLinks from './author_profile/SocialLinks'
import Experience from './author_profile/Experience'
import Education from './author_profile/Education'
import Certifications from './author_profile/Certifications'
import Awards from './author_profile/Awards'
import Affiliations from './author_profile/Affiliations'
import Posts from './author_profile/Posts'

import css from './author_profile/author_profile.scss'

const AuthorProfile = ({ author }) => {
  let name = `${author.firstName} ${author.lastName}`
  if (!author.firstName && !author.lastName) {
    name = author.name
  }

  let title = author.jobTitle
  if (author.postnominals) {
    name = `${name}, ${author.postnominals}`
    title = `${title}, ${author.postnominals}`
  }

  let altText = `{name} {author.jobTitle}`

  return (
    <>
      <HelloBabyMeta
        canonical={babylistUrl(helloBabyAuthors(author.slug))}
        seoDescription={`About ${name}, ${title}. Experience, Education, skills, certifications, and more. See all reviewed and published articles on Babylist.com`}
        socialImage={author.photo.url}
        title={`${name}, ${title} at Babylist`}
      />
      <Box className={classNames(css.authorProfile)}>
        <Box className={classNames(css.authorProfileHero)}>
          <Box className={classNames(css.authorProfileTitle)}>
            {author.photo ? (
              <Box>
                <Image
                  alt={altText}
                  className={classNames(css.authorProfileThumbnail)}
                  src={author.photo.url}
                />
              </Box>
            ) : null}
            <h1>{name}</h1>
            <p>{author.jobTitle}</p>
            <SocialLinks author={author} />
          </Box>
        </Box>
        <Box className={classNames(css.authorProfileBody)}>
          <Box id="about" className={classNames(css.authorProfileSection)}>
            <h2>About {author.firstName || author.name}</h2>
            <div
              className="mts mbn"
              dangerouslySetInnerHTML={{ __html: author.longBio }}
            />
          </Box>
          <Experience author={author} />
          <Education author={author} />
          <Certifications author={author} />
          <Awards author={author} />
          <Affiliations author={author} />
        </Box>
        <Posts author={author} />
      </Box>
    </>
  )
}

export default AuthorProfile
